"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedContentContainerSchema = void 0;
exports.RelatedContentContainerSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/related-content-container.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "RelatedContentContainer",
    "description": "Add inline related content with or without a label for the container",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:related-content-container"
            ]
        },
        "contents": {
            "type": "array",
            "items": {
                "anyOf": [
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/audio-episodes.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/audio-series.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/collections.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/energy-drinks.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/episode-videos.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/event-profiles.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/event-series.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/externals.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/films.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/image-galleries.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/judges.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/live-videos.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/locations.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/occasion-campaigns.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/partner-profiles.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/person-profiles.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/photographers.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/project-profiles.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/rally-drivers.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/recap-videos.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/results-standings.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/shows.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/stories.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/team-profiles.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/trailer-videos.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/tv-commercials.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/videos.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/videos-360.schema.json"
                    }
                ]
            }
        },
        "label": {
            "type": "string"
        }
    },
    "required": [
        "type",
        "contents"
    ]
};
//# sourceMappingURL=data:application/json;base64,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